import { FundBasketStrategy } from "creso-core/types";
import { cn } from "web-design-system";
import { cva } from "class-variance-authority";
import { Conservative } from "./icons/conservative";
import { Aggressive } from "./icons/aggressive";
import { Moderate } from "./icons/moderate";

const variants = cva(
  "p-2 flex rounded-md shrink-0 items-center justify-center size-9",
  {
    variants: {
      strategy: {
        conservative: "bg-tag-green text-tag-green-foreground",
        moderate: "bg-tag-blue text-tag-blue-foreground",
        aggressive: "bg-tag-red text-tag-red-foreground",
      },
      size: {
        sm: "size-8 rounded-sm",
        default: "",
      },
      defaultVariants: {
        variant: "conservative",
        size: "default",
      },
    },
  }
);

export function BasketIcon(props: {
  strategy: FundBasketStrategy;
  size?: "sm" | "default";
}) {
  const { strategy, size } = props;

  return (
    <div className={cn(variants({ strategy, size }))}>
      {strategy === "aggressive" && <Aggressive className="size-full" />}
      {strategy === "conservative" && <Conservative className="size-full" />}
      {strategy === "moderate" && <Moderate className="size-full" />}
    </div>
  );
}
